import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import { branchingQueryKeys } from "~/branching/data-source/api/branching-query-options";

/**
 * Refreshes everything branching caches for a System after a commit moved one of its branches:
 * branches, heads, histories and summaries. Callers outside `branching/` use this rather than
 * `branchingQueryKeys`, so branching stays free to change its cache layout.
 */
export function useInvalidateSystemBranching() {
  const queryClient = useQueryClient();
  return useCallback(
    (systemId: string) => queryClient.invalidateQueries({ queryKey: branchingQueryKeys.system(systemId) }),
    [queryClient],
  );
}
